/**
 * 감사 로그 전용 날짜+시간 포맷 유틸 (Asia/Seoul 고정)
 *
 * 공용 `datetime.ts` 는 date-fns `format` 만 써서 런타임 로컬 TZ 로 렌더된다. 감사 이력은
 * "누가 언제 무엇을 고쳤나"를 다투는 기록이라 보는 사람의 시간대에 따라 날짜가 달라지면
 * 안 되므로, 감사 경로만 KST 고정으로 돌리는 전용 포맷터를 둔다.
 * (KST 계산은 `shared/common/kst.ts` 의 `kstDate` 로 일원화하고, 여기서는 감사 전용 표기만 얹는다.)
 */
import { format } from 'date-fns';
import { kstDate } from '@aegislab/shared';

/** ISO → "2026. 05. 11. 00:30" (KST) / null·빈 문자열 → "-" */
export function formatAuditDateTime(iso: string | null): string {
  if (!iso) return '-';
  return format(kstDate(iso), 'yyyy. MM. dd. HH:mm');
}

/** ISO → "05. 11. 00:30" (KST) — year 없음, 표/카드 열 폭용 / null·빈 문자열 → "-" */
export function formatAuditDateTimeShort(iso: string | null): string {
  if (!iso) return '-';
  return format(kstDate(iso), 'MM. dd. HH:mm');
}

/** ISO → "5/11 00:30" (KST) — 드릴다운 좁은 패널용 축약 / null·빈 문자열 → "-" */
export function formatAuditDateTimeCompact(iso: string | null): string {
  if (!iso) return '-';
  return format(kstDate(iso), 'M/dd HH:mm');
}
